<template><div><h2>Checker</h2>
<ul>
<li>[enhance] 不可选项同样触发事件 on-item-click #1144</li>
</ul>
<h2>FormPreview</h2>
<ul>
<li>[fix] 修复 less 变量：form-preview-button-primary-color</li>
<li>[feature] 支持 prop:name 以方便函数调用 #1123</li>
</ul>
<h2>Masker</h2>
<ul>
<li>[feature] 支持通过prop设置是否全屏显示</li>
</ul>
<h2>Selector</h2>
<ul>
<li>[fix] 修复Selector不能设置name属性的问题#1133</li>
<li>[enhance] Selector的value支持布尔型. @rbao</li>
</ul>
<h2>Swipeout</h2>
<ul>
<li>[fix] 修复来回滑动时左侧菜单可能会被滑出 #1139</li>
</ul>
<h2>XDialog</h2>
<ul>
<li>[fix] 修复初始化时 value 值为 true 无效的问题 #1138</li>
</ul>
</div></template><script>
export default {
  head: {"title":" | VUX - Vue 移动端 UI 组件库","ignoreSuffixChar":"|"}
}
  </script>


// WEBPACK FOOTER //
// v2.1.1-rc.14_zh-CN-324.vue?c4dc1f0e